import { useState, useEffect } from "react";
import { getCategoryId } from "template-store/services/solution-categories-service";
import { getSolutionCategoryPageLink, getSolutionsHomeLink } from "template-store/services/solution-links-service";
import { trackEvent } from "services/bigbrain-service";
import { MENU_CATEGORY_CLICKED } from "/constants/bigbrain-event-types";
import { HOME_ID } from "template-store/constants/categories";
import Favorite from "monday-ui-react-core/dist/icons/Favorite";
import { componentStyles } from "./menu-component.scss";
import { getLastPartOfUrl } from "utils/url";
import classnames from "classnames";

const MenuComponent = ({ allCategories, selectedCategoryId }) => {
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    // Get the last word from the current URL
    const lastWordFromURL = getLastPartOfUrl(window.location.pathname);

    // Check if the last word exists
    if (lastWordFromURL) {
      setSelectedItem(lastWordFromURL);
    }
  }, []);

  const navigationItemClicked = (id) => {
    trackEvent(MENU_CATEGORY_CLICKED, { kind: id });
  };

  const handleItemClick = (item, id) => {
    navigationItemClicked(id);
  };

  const categories = allCategories.map((categoryData, index) => {
    const id = getCategoryId(categoryData);
    const link = getSolutionCategoryPageLink(id);
    return (
      <a href={link} onClick={() => handleItemClick(id, link)}>
        <div key={index} className={classnames("menu-item", { selected: selectedItem === categoryData.value })}>
          {categoryData.label}
        </div>
      </a>
    );
  });
  return (
    <div className="menu-container">
      <a href={getSolutionsHomeLink()} onClick={() => handleItemClick(HOME_ID, getSolutionsHomeLink())}>
        <div className={classnames("menu-item", { selected: selectedItem && selectedCategoryId === HOME_ID })}>
          <div className="star-icon-wrapper">
            <Favorite />
          </div>
          Featured
        </div>
      </a>
      {categories}
      <style jsx>{componentStyles}</style>
    </div>
  );
};
export default MenuComponent;
